import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  Box,
  Button,
  IconButton,
  Modal,
} from '@mui/material/';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';

import styles from './style';

interface ShortModalProps {
  codeshare: string;
  isShortModalVisible: boolean;
  closeShortModal: () => void;
  redirectToApp: () => void;
  // The video is still muted: a tap anywhere closes the popup and turns the sound on.
  showSoundHint: boolean;
}

// "Rejoins-nous" card at the bottom of the mobile feed: every action of the read only feed opens it.
const ShortModal: React.FC<ShortModalProps> = React.memo((props) => {
  const {
    codeshare,
    closeShortModal,
    isShortModalVisible,
    showSoundHint,
  } = props;
  const [isVisible, setIsVisible] = useState(isShortModalVisible);
  const { t } = useTranslation();

  const getTheApp = useCallback(() => {
    var nativeSchemaUrl = `https://store.soskills.io/short/${codeshare}?redirect=42`;
    window.open(nativeSchemaUrl, '_self');
  }, [codeshare]);

  useEffect(() => {
    if (isShortModalVisible) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 700); // Match duration of animation
      return () => clearTimeout(timer);
    }
  }, [isShortModalVisible]);

  const boxClassName = useMemo(() => {
    let name = 'fade-in-slide-up';
    if (!isShortModalVisible) {
      name = 'fade-out-slide-down';
    }
    return name;
  }, [isShortModalVisible]);
  const open = useMemo(() => (isShortModalVisible || isVisible), [isShortModalVisible, isVisible]);

  return (
    <Modal
      hideBackdrop
      open={open}
      onClose={closeShortModal}
      onClick={closeShortModal}
    >
      <Box
        sx={styles.card}
        className={boxClassName}
      >
        <Box sx={styles.logoBadge}>
          <Box component="img" src="/logo-black.png" alt="" sx={styles.logo} />
        </Box>
        <IconButton
          aria-label={t('mobileFeed.close')}
          onClick={closeShortModal}
          sx={styles.close}
        >
          <Close fontSize="inherit" />
        </IconButton>
        <Box component="span" sx={styles.title}>
          {t('mobileFeed.joinTitle')}
        </Box>
        <Box component="span" sx={styles.description}>
          {t('descriptionShortModal')}
        </Box>
        <Button
          variant="contained"
          disableElevation
          onClick={getTheApp}
          sx={styles.openApp}
        >
          {t('mobileFeed.openApp')}
        </Button>
        {showSoundHint && (
          <Box component="span" sx={styles.hint}>
            {t('mobileFeed.soundHint')}
          </Box>
        )}
      </Box>
    </Modal>
  )
});

export default ShortModal;
